import React from 'react'
import styles from '../containers/launchPage.module.scss'

type LaunchButtonProps = {
  label: string
  onClick?: () => void
  variant?: 'primary' | 'accent' | 'secondary' | 'ghost'
  pulse?: boolean
  className?: string
}

export const LaunchButton: React.FC<LaunchButtonProps> = ({
  label,
  onClick,
  variant = 'primary',
  pulse = false,
  className,
}) => {
  const variantClass =
    variant === 'accent'
      ? styles.accentButton
      : variant === 'secondary'
      ? styles.secondaryButton
      : variant === 'ghost'
      ? styles.ghostButton
      : styles.primaryButton

  return (
    <button
      type="button"
      onClick={onClick}
      className={`${styles.launchButton} ${variantClass} ${
        pulse ? styles.pulse : ''
      } ${className ?? ''}`}
    >
      {label}
    </button>
  )
}
